import 'lightcase';

function init() {

    if ($('#js-popup').length) {
        $('html').addClass('lightcase-isBusinessPopup c-lightcase--transparent c-lightcase--noclose');
        lightcase.start({
            href: '#js-popup',
            overlayOpacity: '.75',
            closeOnOverlayClick: false,
            useKeys: false,
            maxWidth: 450,
            onFinish: function () {
                $('#lightcase-nav').remove('.lightcase-icon-close');
            }
        });
    }

    /*
    * Optional parameters
    * - lightcase-modal: trigger modal popup behaviour (no close button and background close click)
    * - lightcase-transparent: add 'c-lightcase--transparent' class to the html-element
    * Usage:
    * - add the lightcase-modal or lightcase-transparent attribute to the data-rel
    */
    $('a[data-rel^=lightcase]').lightcase({
        labels: {
            'sequenceInfo.of': ' - '
        },
        onInit: {
            modalCheck: function () {
                let isModal = $(this).data('rel').indexOf('lightcase-modal') !== -1;
                lightcase.settings.closeOnOverlayClick = !isModal;

                let isTransparent = $(this).data('rel').indexOf('lightcase-transparent') !== -1;
                if(isTransparent) {$('html').addClass('c-lightcase--transparent'); }
            }
        },
        onFinish: {
            modalCheck: function () {
                let isModal = $(this).data('rel').indexOf('lightcase-modal') !== -1;
                $(".lightcase-icon-close").toggle(!isModal);
            },
            closeButton: function () {
                $('.js-close-popup').on('click', function (e) {
                    e.preventDefault();
                    lightcase.close();
                });
            }
        },
        onCleanup: {
            modalCheck: function() {
                $('html').removeClass('lightcase-isBusinessPopup c-lightcase--transparent c-lightcase--noclose');
            }
        }
    });
}

$(document).ready(init);
